import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLogged: false,
  accessToken: '',
  userDetails: {},
  venueDetails: {},
  venueCourts: []
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, { payload }) => {
      state.isLogged = true;
      state.accessToken = payload.token;
      state.userDetails = payload.authState;
    },
    updateVenueDetails: (state, { payload }) => {
      state.venueDetails = payload.venueDetails;
    },
    updateVenueCourts: (state, { payload }) => {
      state.venueCourts = payload.venueCourts;
    },
    logOut: (state) => {
      state.isLogged = false;
      state.userDetails = {};
      state.accessToken = '';
      state.venueDetails = {};
    },
  },
});

export const { loginSuccess, logOut, updateVenueDetails, updateVenueCourts } = authSlice.actions;
export default authSlice.reducer;